import { render } from "./caseList.vue?vue&type=template&id=3a8616c6&scoped=true&ts=true"
import script from "./caseList.vue?vue&type=script&lang=ts"
export * from "./caseList.vue?vue&type=script&lang=ts"

import "./caseList.vue?vue&type=style&index=0&id=3a8616c6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8616c6"]])

export default __exports__